import React, { useState } from 'react';
import Navbar from '../../components/Navbar/index.js';
import Sidebar from '../../components/Sidebar/index.js';
import Footer from '../../components/Footer/index.js';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import { Helmet } from "react-helmet";
import FlyFishingImage1 from '../../images/fly_fishing/flyfishing1.png'
import FlyFishingImage2 from '../../images/fly_fishing/flyfishing2.png'
import FlyFishingImage3 from '../../images/fly_fishing/flyfishing3.png'
import FlyFishingImage4 from '../../images/fly_fishing/flyfishing4.png'
import FlyFishingImage5 from '../../images/fly_fishing/flyfishing5.png'
import FlyFishingImage6 from '../../images/fly_fishing/flyfishing6.png'
import {
  HeroContainer,
  HeroPicture,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight
} from '../../components/HeroSection/HeroElements.js';
import InfoSection from '../../components/InfoSection';

function FlyFishing() {
  const [isOpen, setIsOpen] = useState(false);

  const homeObjOne = {
    id: 'flyfishing',
    lightBg: false,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Guided Fly Fishing Trips',
    headline: 'Your ticket to world-class fly fishing',
    description:
      "Fairway Hunters co-founder and licensed fly fishing guide Jason Deaver offers all-inclusive guided fly fishing trips on the rivers and lakes in and around Redding, CA.  This includes the world-famous Sacramento River, home of some of the best fly fishing in the world.  Trips are open to all ages and skill levels, and all amenities - rods, flies, boats, food, water, and most importantly, great fishing - are all included.  Click the button below to get connected with Jason and schedule your trip now!",
    buttonLabel: 'Go Fishing!',
    imgStart: false,
    img: FlyFishingImage4,
    alt: 'tourneys',
    dark: false,
    primary: true,
    darkText: true,
    routeButton: true,
    buttonDestination: 'mailto:jdeaver100@gmail.com'
  };

  const spanStyle = {
    background: '#efefef',
    color: '#000000'
  }

  const slideshowDivStyle = {

  }

  const textOverlayDivStyle = {
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: '10px',
    height: "80vh",
    width: "100vw",
    top: 0,
    left: 0,
    justifyContent: "center",
    alignItems: "center",
  }
  
  const slideshowImageBackgroundStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    minHeight: '80vh',
    backgroundPosition: "center",
    position: 'relative',
    width: "100vw",
    padding: "0",
    margin: "0"
  }

  const slideshowImageOverlayStyle = {
    position: "absolute",
    zIndex: 2,
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
    padding: "0",
    margin: "0"
  }

  const slideImages = [
    {
      url: FlyFishingImage1,
      caption: 'Slide 1'
    },
    {
      url: FlyFishingImage2,
      caption: 'Slide 2'
    },
    {
      url: FlyFishingImage3,
      caption: 'Slide 3'
    },
    {
      url: FlyFishingImage4,
      caption: 'Slide 4'
    },
    {
      url: FlyFishingImage5,
      caption: 'Slide 5'
    },
    {
      url: FlyFishingImage6,
      caption: 'Slide 6'
    },
  ];

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
        <Helmet>
          <title>Fly Fishing</title>
          <meta
            name="description"
            content="Fly fishing trips"
          />
          <meta
            name="keywords"
            content="Golf, Hunting, Fairway, Hunters, Faith, God, Jesus, Christ, Redding, California, Apparel, Hats, fly, fishing, sacramento, river"
          />
        </Helmet>
        <Sidebar isopen={isOpen} toggle={toggle} />
        <Navbar toggle={toggle} />
          <>
          <div style={{ ...slideshowDivStyle }}>
            <Slide>
              {slideImages.map((slideImage, index)=> (
                <div key={index}>
                  <div style={{ ...slideshowImageBackgroundStyle, 'backgroundImage': `linear-gradient(to bottom, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9)), url(${slideImage.url})` }}>
                    <div style={{ ...slideshowImageOverlayStyle }}>
                      <div style={{ display: "flex", height: "100%", width: "100%", alignItems: "center", justifyContent: "center" }}>
                        <img src={slideImage.url} style={{ maxHeight: "80vh", maxWidth: "100vw", alignSelf: "center", boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.4)", borderRadius: "5px" }} />
                      </div>
                    </div>
                    {/* <img src={slideImage.url} /> */}
                    {/* <span style={spanStyle}>{slideImage.caption}</span> */}
                  </div>
                </div>
              ))} 
            </Slide>
            <div style={{ ...textOverlayDivStyle }}>
              <div style={{ display: "flex", height: "100%", width: "100%", alignItems: "center", justifyContent: "center" }}>
                <HeroContent>
                  <HeroH1>Fly Fishing</HeroH1>
                  <HeroP>
                    World-Class Guided Trips
                  </HeroP>
                </HeroContent>
              </div>
            </div>
          </div>
          <InfoSection {...homeObjOne} />
          <Footer />
          </>

        
    </>
  );
}

export default FlyFishing;